import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ApiDataResponse } from '@shared/model/api-response.model';
import { UserContext, GetLanguages_Result, GainsightInfo } from '@typeDefs/home/responses/home';
import { Observable } from 'rxjs';
import { BulletinsGetIndex_Result } from '@typeDefs/employee/responses/employee';

@Injectable({
  providedIn: 'root',
})
export class HomeApiService {
  private http = inject(HttpClient);

  private userContext$ = this.http.get<UserContext>('/Account/GetUserContext');
  userContext = toSignal(this.userContext$, { initialValue: null });

  getPdfFile(attachmentID: string): Observable<Blob> {
    const url = '/Document/GetPdfFile';
    const params = new HttpParams().set("attachmentID", attachmentID);

    return this.http.get(url, { params: params, responseType: 'blob' });
  }

  getPerformanceAcknowledgementStatus(): Observable<ApiDataResponse<boolean>> {
    return this.http.get<ApiDataResponse<boolean>>('/Performance/GetPerformanceAcknowledgementStatus');
  }

  checkHasReviewReadyToFinalize(): Observable<ApiDataResponse<boolean>> {
    return this.http.get<ApiDataResponse<boolean>>('/Performance/CheckHasReviewReadyToFinalize');
  }

  getBulletins(sectionToLoad: string): Observable<BulletinsGetIndex_Result[]> {
    const params = new HttpParams().set('sectionToLoad', sectionToLoad);
    return this.http.get<BulletinsGetIndex_Result[]>('/Employee/GetBulletinsGetIndex', { params: params });
  }

  getLanguages(): Observable<GetLanguages_Result[]> {
    return this.http.get<GetLanguages_Result[]>('/Home/GetLanguages');
  }

  getGainsightInfo(): Observable<GainsightInfo> {
    return this.http.get<GainsightInfo>('/home/getgainsightinfo');
  }
}
